import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';

// Third-party
import { useSetAtom } from 'jotai';

// Atoms
import { openedMessageAtom } from '@/components/pages/conversations/SocialInbox/atoms';

// Types
import { MESSAGE_FILTER_META } from '@/components/pages/conversations/SocialInbox/const';
import type { SocialInboxType } from '@/components/pages/conversations/SocialInbox/types';

export const useMessageFilter = () => {
    const pathname = usePathname();
    const router = useRouter();
    const setOpenedMessage = useSetAtom(openedMessageAtom);

    const getFilterFromUrl = (): SocialInboxType | null => {
        for (const filter of Object.keys(MESSAGE_FILTER_META)) {
            if (pathname?.includes(filter)) {
                return filter;
            }
        }
        return null;
    };

    const navigateToFilter = (filter: SocialInboxType) => {
        const url = MESSAGE_FILTER_META[filter].url;
        if (url) {
            setOpenedMessage(null);
            router.push(url);
        }
    };

    return {
        navigateToFilter,
        messageFilter: getFilterFromUrl()
    };
};
